<template>
  <div class="hot">
    <div class="head">
      <div class="seconds">
        <span>热卖秒杀:</span>
        <van-count-down :time="time">
          <template #default="timeData">
            <span class="block">{{ timeData.hours }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.minutes }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.seconds }}</span>
          </template>
        </van-count-down>
      </div>
      <div>
        <router-link to="">更多秒杀商品></router-link>
      </div>
    </div>
    <div class="product">
      <ul>
        <li v-for="(item,index) of datas" :key="index">
          <div><img :src="item.pic"></div>
          <div class="price">
            <p>
              <span>{{$setInfoDecimal(item.goods_price)}}</span>
              <span>{{item.discount}}</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      time: 30 * 60 * 60 * 1000,
      datas: [
        // { goods_sn: 1, pic: require('../../../assets/product/1.png'), goods_price: 250, discount: 250 },
        // { goods_sn: 2, pic: require('../../../assets/product/2.png'), goods_price: 250, discount: 250 },
        // { goods_sn: 3, pic: require('../../../assets/product/3.png'), goods_price: 250, discount: 250 },
        // { goods_sn: 4, pic: require('../../../assets/product/4.png'), goods_price: 250, discount: 250 },
        // { goods_sn: 5, pic: require('../../../assets/product/5.png'), goods_price: 250, discount: 250 },
        // { goods_sn: 6, pic: require('../../../assets/product/6.png'), goods_price: 250, discount: 250 },
        // { goods_sn: 7, pic: require('../../../assets/product/7.png'), goods_price: 250, discount: 250 },
        // { goods_sn: 8, pic: require('../../../assets/product/8.png'), goods_price: 250, discount: 250 },

      ]
    }
  }

}
</script>
<style lang="scss" scoped>
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #ee0a24;
}
.hot {
  //   clear: both;
  font-size: 0.25rem;
  width: 6.58rem;
  border-radius: 5px;
  padding: 0.2rem;
  margin: auto;
  margin-top: 0.2rem;
  //   border: 2px solid #e4e4e4;
  box-shadow: 0px 0px 5px#cecece;
  background: white;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
      color: #000000;
    }
    .seconds {
      display: flex;
    }
  }
  .product {
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 1.44rem;
        margin: 0.1rem 0;
        img {
          width: 100%;
        }
      }
    }
    .price {
      p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        :nth-child(1) {
          color: #ff1616;
          font-size: 0.25rem;
          font-weight: 500;
        }
        :nth-child(2) {
          font-size: 0.2rem;
          color: #bbbbbb;
          text-decoration: line-through;
        }
      }
    }
  }
}
</style>